import type { DataUpload } from '@/common/data-upload';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

/**
 * Lists TILESET data uploads whose conversion is still queued/processing on the
 * tile server. Used on startup to resume tracking conversions from earlier
 * sessions — the server keeps converting regardless of any browser tab.
 */
export async function getActiveTilesets(): Promise<DataUpload[]> {
	const response = await axios.get(API_URLS.DATA_UPLOAD.TILESET_ACTIVE);
	return getResponse<DataUpload[]>(response.data) ?? [];
}
